import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function UploadFile(formData) {
  return client.post("Upload", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

function InsertFile(file) {
  return client.post("Files/InsertFile", prepareDataRequest(file));
}

function GetFiles(sourceType, sourceId) {
  const data = {
    SourceType: sourceType,
    SourceId: sourceId
  };
  return client.post("Files/GetFiles", prepareRequest(data));
}

function DeleteFile(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Files/DeleteFile", prepareDataRequest(item));
}

export { InsertFile, GetFiles, DeleteFile, UploadFile };